export default __webpack_public_path__ + "assets/new-app-version-71c5c5623e05a5b90d5e69f6186dfa77.svg";